import { Fragment } from "react";
import { Carousel } from "react-bootstrap";
import im1 from "../media/IMG1.jpeg";
import im2 from "../media/IMG2.jpeg";
import im3 from "../media/IMG3.jpeg";
import im4 from "../media/IMG4.jpeg";


function Fotografie() {
  return (
    <Fragment>
      <Carousel>
        <Carousel.Item>
          <img className="d-block w-100" src={im1} alt="First slide" />
        </Carousel.Item>

        <Carousel.Item>
          <img className="d-block w-100" src={im2} alt="Second slide" />
        </Carousel.Item>
        <Carousel.Item>
          <img className="d-block w-100" src={im3} alt="Third slide" />
        </Carousel.Item>
        <Carousel.Item>
          <img className="d-block w-100" src={im4} alt="Third slide" />
        </Carousel.Item>
        
      </Carousel>
    </Fragment>
  );
}

export default Fotografie;
